import { render, staticRenderFns } from "./receiving-address.vue?vue&type=template&id=175a4d1a&scoped=true&"
import script from "./receiving-address.vue?vue&type=script&lang=js&"
export * from "./receiving-address.vue?vue&type=script&lang=js&"
import style0 from "./receiving-address.vue?vue&type=style&index=0&id=175a4d1a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175a4d1a",
  null
  
)

export default component.exports